import { NgModule } from '@angular/core';
import { RouterComponent } from './router.component';

@NgModule({
  imports: [
  ],
  declarations: [RouterComponent],
  exports: [RouterComponent]
})
export class RouterModule { }
